<template>
  <b-modal
    v-model="modalOpen"
    centered
    title="سجل الخطط"
    footer-class="removed"
    class="edit-modal"
    id="activityModal"
    no-close-on-backdrop
  >
    <h6 class="mb-1">اختر سنة لعرض أرشيف الخطة</h6>
    <b-list-group class="border" flush>
      <b-list-group-item
        style="cursor: pointer"
        v-for="(plan, index) in [...archivedPlans]"
        :key="index"
        @click="
          $router.push({ name: 'annual-plan', params: { year: plan.year } })
        "
        size="lg"
        >{{ plan.year }}</b-list-group-item
      >
    </b-list-group>
  </b-modal>
</template>

<script>
import { BModal, BListGroup, BListGroupItem } from "bootstrap-vue";
import { mapGetters } from "vuex";
export default {
  components: {
    BModal,
    BListGroup,
    BListGroupItem,
  },
  props: {
    value: Boolean,
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    ...mapGetters("NgoPlan/Plan", ["archivedPlans", "currentPlan"]),
  },
};
</script>
